import { TooltipInfoIcon } from "@vega-core/components/Tooltip/TooltipInfoIcon";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type CustomLegendVariant = "horizontal" | "vertical";

export const CustomLegend = ({
  name = "unknown",
  displayValue,
  color,
  shouldShowEmptyState = false,
  variant = "vertical",
  tooltip,
}: {
  name?: string;
  displayValue?: string;
  color: string;
  shouldShowEmptyState?: boolean;
  variant?: CustomLegendVariant;
  tooltip?: string;
}) => (
  <div
    className={cnTwMerge(
      "flex items-center gap-2",
      variant === "vertical"
        ? "py-2 w-full justify-between"
        : "py-1 justify-start",
    )}
  >
    <div className="flex items-center gap-2 min-w-0">
      <div
        className={cnTwMerge(
          "w-2.5 lg:w-3 h-2.5 lg:h-3 rounded-sm flex-shrink-0",
          shouldShowEmptyState ? "opacity-30" : "",
        )}
        style={{ background: color }}
      />
      <div
        className={cnTwMerge(
          "text-text/primary body-small-semibold",
          variant === "vertical" ? "truncate" : "whitespace-nowrap",
        )}
      >
        {name}
      </div>
      {tooltip ? <TooltipInfoIcon content={tooltip} /> : null}
    </div>
    {!shouldShowEmptyState && displayValue ? (
      <div className="text-text/secondary body-small-medium flex-shrink-0 ml-2">
        {displayValue}
      </div>
    ) : null}
  </div>
);
